var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "center-scan-in-trip"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('legend', {
    staticClass: "header1"
  }, [_vm._v("Canvas Bag In-Scan"), _c('b', {
    staticStyle: {
      "float": "right",
      "cursor": "pointer",
      "color": "#0f70dc"
    },
    on: {
      "click": _vm.openOffLoadMaster
    }
  }, [_vm._v("Mark Shipment Offload")])]), _vm._v(" "), _c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.Loading
    },
    on: {
      "update:active": function($event) {
        _vm.Loading = $event
      }
    }
  }), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "form-group1 row"
  }, [
    [_c('div', {
      staticClass: "col-md-4"
    }, [_c('b-form-fieldset', [_c('label', [_vm._v("Vehicle Number/ Trip ID")]), _c('span', {
      staticClass: "text-danger"
    }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
      attrs: {
        "left": "<i class='fa fa-truck'></i>"
      }
    }, [_c('multiselect', {
      attrs: {
        "options": _vm.vehicletypelist,
        "label": "text",
        "track-by": "vehicleno",
        "placeholder": "Select Vehicle",
        "show-labels": false,
        "multiple": false,
        "max-height": 300,
        "clearable": false
      },
      on: {
        "select": _vm.selectVehicleType
      },
      model: {
        value: (_vm.vehicletype),
        callback: function($$v) {
          _vm.vehicletype = $$v
        },
        expression: "vehicletype"
      }
    })], 1), _vm._v(" "), (_vm.vehicletypeErr) ? _c('span', {
      staticClass: "text-danger"
    }, [_vm._v(_vm._s(_vm.vehicletypeErr))]) : _vm._e()], 1)], 1)], _vm._v(" "), _c('div', {
      staticClass: "col-md-4"
    }, [_c('b-form-fieldset', [_c('label', [_vm._v("Connection Name")]), _c('span', {
      staticClass: "text-danger"
    }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
      attrs: {
        "left": "<i class='fa fa-users'></i>"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.connectionName),
        expression: "connectionName"
      }],
      class: {
        'form-control': true, 'error': _vm.errors.has('connectionName')
      },
      attrs: {
        "type": "text",
        "placeholder": "Connection Name",
        "name": "connectionName",
        "id": "connectionName",
        "disabled": ""
      },
      domProps: {
        "value": (_vm.connectionName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.connectionName = $event.target.value
        }
      }
    })])], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-4"
    }, [_c('b-form-fieldset', [_c('label', [_vm._v("Vehicle Seal Condition")]), _c('span', {
      staticClass: "text-danger"
    }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
      attrs: {
        "left": "<i class='\tfa fa-archive'></i>"
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.networklocalsealstatus),
        expression: "networklocalsealstatus"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: true
        }),
        expression: "{required:true}"
      }],
      class: {
        'form-control': true, 'error': _vm.errors.has('networklocalsealstatus')
      },
      attrs: {
        "name": "networklocalsealstatus"
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.networklocalsealstatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, _vm.checkSealCondition]
      }
    }, [_c('option', {
      attrs: {
        "value": "WithSeal",
        "selected": ""
      }
    }, [_vm._v("With Seal")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "WithSealDamaged"
      }
    }, [_vm._v("With Seal (Damaged)")]), _vm._v(" "), (([1, 3, 5].includes(_vm.connectiontype))) ? _c('option', {
      attrs: {
        "value": "WithoutSeal"
      }
    }, [_vm._v("Without Seal")]) : _vm._e()])]), _vm._v(" "), _c('span', {
      staticClass: "text-danger"
    }, [_vm._v(_vm._s(_vm.vehiclesealconditionErr))])], 1)], 1), _vm._v(" "), (_vm.WithoutSealcon) ? _c('div', {
      staticClass: "col-md-4"
    }, [_c('b-form-fieldset', [_c('label', [_vm._v("Reason")]), _c('span', {
      staticClass: "text-danger"
    }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
      attrs: {
        "left": "<i class='\tfa fa-archive'></i>"
      }
    }, [(([1, 3, 5].includes(_vm.connectiontype))) ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.reason),
        expression: "reason"
      }],
      class: {
        'form-control': true
      },
      attrs: {
        "name": "reason"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.reason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "",
        "selected": "",
        "disabled": ""
      }
    }, [_vm._v("Select Reason")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Brooks and bond trip"
      }
    }, [_vm._v("Brooks and bond trip")])]) : _vm._e()]), _vm._v(" "), (_vm.reasonIerr && !_vm.reason) ? _c('span', {
      staticClass: "text-danger"
    }, [_vm._v(_vm._s(_vm.reasonIerr))]) : _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('reason')),
        expression: "errors.has('reason')"
      }],
      staticClass: "text-danger"
    }, [_vm._v(_vm._s(_vm.errors.first('reason')))])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-md-4"
    }, [_c('b-form-fieldset', [_c('label', [_vm._v("Vehicle Seal No")]), (((_vm.networklocalsealstatus != 'WithoutSeal') || (_vm.connectiontype != 1 && _vm.connectiontype != 3 && _vm.connectiontype != 5))) ? _c('span', {
      staticClass: "text-danger"
    }, [_vm._v("*")]) : _vm._e(), _vm._v(" "), _c('b-input-group', {
      attrs: {
        "left": "<i class='\tfa fa-archive'></i>"
      }
    }, [((_vm.networklocalsealstatus == 'WithoutSeal' || _vm.connectiontype == 1 || _vm.connectiontype == 3)) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.vehiclesealno),
        expression: "vehiclesealno"
      }],
      class: {
        'form-control': true
      },
      attrs: {
        "type": "text",
        "placeholder": "Enter Vehicle Seal No",
        "name": "vehiclesealno",
        "id": "vehiclesealno"
      },
      domProps: {
        "value": (_vm.vehiclesealno)
      },
      on: {
        "keyup": _vm.removeError,
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.vehiclesealno = $event.target.value
        }
      }
    }) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.vehiclesealno),
        expression: "vehiclesealno"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: true
        }),
        expression: "{required:true}"
      }],
      class: {
        'form-control': true, 'error': _vm.errors.has('vehiclesealno')
      },
      attrs: {
        "type": "text",
        "placeholder": "Enter Vehicle Seal No",
        "name": "vehiclesealno",
        "id": "vehiclesealno"
      },
      domProps: {
        "value": (_vm.vehiclesealno)
      },
      on: {
        "keyup": _vm.removeError,
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.vehiclesealno = $event.target.value
        }
      }
    })]), _vm._v(" "), (_vm.vehiclesealnoErr && !_vm.reason) ? _c('span', {
      staticClass: "text-danger"
    }, [_vm._v(_vm._s(_vm.vehiclesealnoErr))]) : _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('vehiclesealno')),
        expression: "errors.has('vehiclesealno')"
      }],
      staticClass: "text-danger"
    }, [_vm._v("The Vehicle Seal No field is required.")])], 1)], 1), _vm._v(" "), (_vm.isDestination == true) ? _c('div', {
      staticClass: "col-md-4"
    }, [_c('b-form-fieldset', [_c('label', [_vm._v("Close KM")]), _c('span', {
      staticClass: "text-danger"
    }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
      attrs: {
        "left": "<i class='\tfa fa-car'></i>"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.networklocalclosekm),
        expression: "networklocalclosekm"
      }],
      class: {
        'form-control': true, 'error': _vm.errors.has('Closekm')
      },
      attrs: {
        "type": "text",
        "placeholder": "Enter Close KM",
        "name": "Closekm",
        "id": "Closekm"
      },
      domProps: {
        "value": (_vm.networklocalclosekm)
      },
      on: {
        "keyup": _vm.clearCloseKMError,
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.networklocalclosekm = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "text-danger"
    }, [_vm._v(_vm._s(_vm.vehicleclosekmErr))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.InvalidReason) ? _c('div', {
      staticClass: "col-md-4"
    }, [_c('label', [_vm._v("Invalid Seal Reason")]), _c('span', {
      staticClass: "text-danger"
    }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
      attrs: {
        "left": "<i class='fa fa-building'></i>"
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.invalidsealreason),
        expression: "invalidsealreason"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: true
        }),
        expression: "{required:true}"
      }],
      staticClass: "form-control",
      class: {
        'form-control': true, 'error': _vm.errors.has('Invalid Seal Reason')
      },
      attrs: {
        "name": "Invalid Seal Reason"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.invalidsealreason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "",
        "selected": "",
        "disabled": ""
      }
    }, [_vm._v("Select Seal Reason")]), _vm._v(" "), _vm._l((_vm.InvalidSealReasonArray), function(reason) {
      return _c('option', {
        domProps: {
          "value": reason.displayfield
        }
      }, [_vm._v(_vm._s(reason.displayfield))])
    })], 2)]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('Invalid Seal Reason')),
        expression: "errors.has('Invalid Seal Reason')"
      }],
      staticClass: "text-danger"
    }, [_vm._v(_vm._s(_vm.errors.first('Invalid Seal Reason')) + " ")])], 1) : _vm._e()
  ], 2), _vm._v(" "), _c('div', {
    staticClass: "form-group1 row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.InScanVehicle()
      }
    }
  }, [_vm._v("In Scan Vehicle Seal No")]), _vm._v("\n                    "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.getPendingWorkBagList
    }
  }, [_vm._v("Pending")]), _vm._v("  \n                  "), _c('button', {
    staticClass: "btn btn-warning",
    staticStyle: {
      "margin-bottom": "4px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openPaperWorkBagCard
    }
  }, [_vm._v("Paper Work")]), _vm._v("\n                    \n                  "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "background-color": "#3c7ec5",
      "border-color": "#3c7ec5"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.allowShoratge
    },
    on: {
      "click": function($event) {
        return _vm.openPendingInscanList('Pending', 'MarkShortage')
      }
    }
  }, [_vm._v("Mark Bag Shortage")]), _vm._v("  \n                  "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button",
      "size": "sm",
      "disabled": _vm.disableclosevehiclebtn || _vm.vehicletypeitem.isdestination == true || _vm.networklocalvehicleitem.isdestination == true
    },
    on: {
      "click": function($event) {
        return _vm.closeVehicle('loadbag')
      }
    }
  }, [_vm._v("Load Bag")]), _vm._v("  \n\n                  "), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button",
      "disabled": _vm.disableclosevehiclebtn || _vm.vehicletypeitem.isdestination == true || _vm.networklocalvehicleitem.isdestination == true
    },
    on: {
      "click": _vm.closeVehicle
    }
  }, [_vm._v("Close Vehicle")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openUnloadingSheetModel
    }
  }, [_vm._v("Print Unloading Sheet")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.AllowDepartureSeal),
      expression: "AllowDepartureSeal"
    }],
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Vehicle Departure Seal No")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-archive'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.networklocaldeparturesealno),
      expression: "networklocaldeparturesealno"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|checkprefix'),
      expression: "'required|checkprefix'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('Sealno')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Vehicle Seal No",
      "name": "Sealno",
      "id": "Sealno"
    },
    domProps: {
      "value": (_vm.networklocaldeparturesealno)
    },
    on: {
      "keyup": _vm.clearDepartureSealNoError,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.networklocaldeparturesealno = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.networklocaldeparturesealnoErr))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Sealno')),
      expression: "errors.has('Sealno')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Sealno')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.IsSavedDepartureSeal
    },
    on: {
      "click": function($event) {
        return _vm.UpdateVehicle('networklocal')
      }
    }
  }, [_vm._v("Save")]), _vm._v("  \n                  "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-bottom": "4px",
      "background-color": "#3c7ec5",
      "border-color": "#3c7ec5"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.disableBtn == 1 ? false : true
    },
    on: {
      "click": _vm.openUpdateModal
    }
  }, [_vm._v("Update Vehicle Seal No")]), _vm._v("  \n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group1 row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Bag Seal Condition")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-archive'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sealtype),
      expression: "sealtype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('Seal Condition')
    },
    attrs: {
      "name": "Seal Condition",
      "disabled": _vm.disableFieldforDeparture
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sealtype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v("Select Seal Condition")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "WithSeal"
    }
  }, [_vm._v("WithSeal")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "WithoutSeal"
    }
  }, [_vm._v("WithoutSeal")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Seal Condition')),
      expression: "errors.has('Seal Condition')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Seal Condition')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Bag Condition")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-archive'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bagcondition),
      expression: "bagcondition"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('Bag Condition')
    },
    attrs: {
      "name": "Bag Condition",
      "disabled": _vm.disableField || _vm.disableFieldforDeparture
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.bagcondition = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Torn/Damaged"
    }
  }, [_vm._v("Torn/Damaged")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "WithoutSeal"
    }
  }, [_vm._v("WithoutSeal")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Intact",
      "selected": ""
    }
  }, [_vm._v("Intact")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Bag Condition')),
      expression: "errors.has('Bag Condition')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Bag Condition')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Bag Seal No")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-archive'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bagsealno),
      expression: "bagsealno"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('Bag Seal No')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Bag Seal No",
      "name": "Bag Seal No",
      "id": "bagsealno",
      "disabled": _vm.disableField || _vm.disableFieldforDeparture,
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.bagsealno)
    },
    on: {
      "keypress": function($event) {
        return _vm.checkBarcode($event)
      },
      "cut": function($event) {
        $event.preventDefault();
      },
      "paste": function($event) {
        $event.preventDefault();
      },
      "copy": function($event) {
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bagsealno = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Bag Seal No')),
      expression: "errors.has('Bag Seal No')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Bag Seal No')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "-2px"
    }
  }, [(_vm.OffloadReasontype) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Offload Reason")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-building'></i>"
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'error': _vm.errors.has('Offload Reason')
    },
    attrs: {
      "options": _vm.offloadreasonlist,
      "selected-option": _vm.offloadreasonitem,
      "disabled": _vm.disableField || _vm.disableFieldforDeparture,
      "placeholder": "Select Offload Reason",
      "name": "Offload Reason"
    },
    on: {
      "select": _vm.selectOffloadReason
    },
    model: {
      value: (_vm.offloadreason),
      callback: function($$v) {
        _vm.offloadreason = $$v
      },
      expression: "offloadreason"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Offload Reason')),
      expression: "errors.has('Offload Reason')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Offload Reason')) + " ")])], 1) : _vm._e()]), _vm._v(" "), (_vm.scanInRes.Destination || _vm.scanInRes.Zone) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "-2px"
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b', [_vm._v("Destination: "), _c('span', {
    staticStyle: {
      "color": "#C21807"
    }
  }, [_vm._v(_vm._s(_vm.scanInRes.Destination))]), _c('br'), _vm._v("\n                    Zone: "), _c('span', {
    staticStyle: {
      "color": "#C21807"
    }
  }, [_vm._v(_vm._s(_vm.scanInRes.Zone))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mpstype),
      expression: "mpstype"
    }],
    staticClass: "form-group1 row"
  }, [_c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "text-align": "right !IMPORTANT"
    }
  }, [_c('div', {
    staticClass: "alert heavybagcls",
    staticStyle: {
      "border": "1px solid red"
    }
  }, [_c('b', {
    staticStyle: {
      "margin": "15%"
    }
  }, [_vm._v(_vm._s(_vm.mpstype))])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-top": "22px"
    }
  }, [_c('b-form-fieldset', [_c('b-input-group', {
    staticStyle: {
      "margin-top": "-37px",
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    style: ((_vm.disablescanInBtn == true) ? 'opacity: 0.8; cursor: not-allowed;' : ''),
    attrs: {
      "type": "submit",
      "size": "sm",
      "disabled": _vm.disablescanInBtn
    },
    on: {
      "click": _vm.ScanIn
    }
  }, [_vm._v("ScanIn")]), _vm._v("  \n                      "), _c('b-button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "background-color": "rgb(60, 126, 197)",
      "border-color": "rgb(60, 126, 197)",
      "color": "white"
    },
    attrs: {
      "type": "reset",
      "size": "sm"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("Reset")]), _vm._v("  \n                      ")], 1)], 1)], 1)]), _vm._v(" "), (_vm.IsPendingInscanBtn) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "color": "blue"
    },
    on: {
      "click": _vm.getPendingInscanBagCount
    }
  }, [_c('b', [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reload Bags Count")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b', [_vm._v("Pending Bags Count: "), _c('span', {
    staticStyle: {
      "color": "#20a8d8",
      "cursor": "pointer",
      "font-weight": "bold"
    },
    on: {
      "click": function($event) {
        return _vm.openPendingInscanList('Pending')
      }
    }
  }, [_vm._v(_vm._s(_vm.PendingBagsCount))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b', [_vm._v("InScanned Bags Count: "), _c('span', {
    staticStyle: {
      "color": "#20a8d8",
      "cursor": "pointer",
      "font-weight": "bold"
    },
    on: {
      "click": function($event) {
        return _vm.openPendingInscanList('InScanned')
      }
    }
  }, [_vm._v(_vm._s(_vm.InScannedBagsCount))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b', [_vm._v("Shortage Bags Count: "), _c('span', {
    staticStyle: {
      "color": "#20a8d8",
      "cursor": "pointer",
      "font-weight": "bold"
    },
    on: {
      "click": _vm.displayShortageBagList
    }
  }, [_vm._v(_vm._s(_vm.ShortageBagsCount))])])])]) : _vm._e()])], 1), _vm._v(" "), (_vm.IsPendingInscanList == true || _vm.ShortageBagRecord.length > 0) ? _c('b-card', [(_vm.ShortageBagRecord.length > 0) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h5', {
    staticClass: "header1"
  }, [_vm._v("Shortage Bags List")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table table-bordered mytable12",
    staticStyle: {
      "width": "98%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Bag No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Final Destination ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Status")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.ShortageBagRecord), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.finalDestinationID))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.status))])])
  }), _vm._v(" "), (_vm.ShortageBagRecord.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("No record found")])]) : _vm._e()], 2)])])])]) : _vm._e(), _vm._v(" "), (_vm.IsPendingInscanList) ? _c('div', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2 radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.listtype),
      expression: "listtype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "id": "Ecom",
      "value": "Ecom"
    },
    domProps: {
      "checked": _vm._q(_vm.listtype, "Ecom")
    },
    on: {
      "change": [function($event) {
        _vm.listtype = "Ecom"
      }, _vm.getPendingInscanBagList]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-circle",
    staticStyle: {
      "cursor": "pointer"
    }
  })])]), _c('label', {
    attrs: {
      "for": "Ecom"
    }
  }, [_vm._v("Ecom")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.listtype),
      expression: "listtype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "id": "Cargo",
      "value": "Cargo"
    },
    domProps: {
      "checked": _vm._q(_vm.listtype, "Cargo")
    },
    on: {
      "change": [function($event) {
        _vm.listtype = "Cargo"
      }, _vm.getPendingInscanBagList]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-circle",
    staticStyle: {
      "cursor": "pointer"
    }
  })])]), _c('label', {
    attrs: {
      "for": "Cargo"
    }
  }, [_vm._v("Cargo")])])]), _vm._v(" "), _c('h5', {
    staticClass: "header1"
  }, [_vm._v(_vm._s(_vm.bagstatus) + " List")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table table-bordered mytable12",
    staticStyle: {
      "width": "98%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [(_vm.listtype == 'Ecom') ? _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Bag No")]) : _vm._e(), _vm._v(" "), (_vm.listtype == 'Cargo') ? _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Paper Bag No")]) : _vm._e(), _vm._v(" "), (_vm.listtype == 'Cargo') ? _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Parent MPS")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Final DestinationID")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.PendingInscanBagData), function(data, index) {
    return (_vm.PendingInscanBagData.length > 0) ? _c('tr', [(_vm.listtype == 'Ecom') ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagno))]) : _vm._e(), _vm._v(" "), (_vm.listtype == 'Cargo') ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.paperbagno))]) : _vm._e(), _vm._v(" "), (_vm.listtype == 'Cargo') ? _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "color": "#20a8d8",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.getCargoParentMPSDetails(data)
        }
      }
    }, [_vm._v(_vm._s(data.ParentMPS))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.Status))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.FinalDestinationID))])]) : _vm._e()
  }), _vm._v(" "), (_vm.PendingInscanBagData.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("No record found")])]) : _vm._e()], 2)])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isShoratge) ? _c('b-card', [_c('h5', {
    staticClass: "header1"
  }, [_vm._v("Pending List")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table table-bordered mytable12",
    staticStyle: {
      "width": "98%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Bag No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Final DestinationID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Mark Bag Shortage")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.PendingInscanBagData), function(data, index) {
    return (_vm.PendingInscanBagData.length > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.Status))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.FinalDestinationID))]), _vm._v(" "), (data.markshortageflag == true && data.isLinearFlowEnabledbagFlag == true) ? _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "color": "#20a8d8",
        "cursor": "pointer",
        "font-weight": "bold"
      },
      on: {
        "click": function($event) {
          return _vm.ConfirmbBagShortageMark(data)
        }
      }
    }, [_vm._v("Mark Shortage")]) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), (_vm.PendingInscanBagData.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("No record found")])]) : _vm._e()], 2)])])]) : _vm._e()], 1)]), _vm._v(" "), (_vm.ConfirmBagShortage == true) ? _c('b-modal', {
    attrs: {
      "size": "md",
      "title": "Are You Sure"
    },
    model: {
      value: (_vm.ConfirmBagShortage),
      callback: function($$v) {
        _vm.ConfirmBagShortage = $$v
      },
      expression: "ConfirmBagShortage"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingSearch
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingSearch = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.CloseConfirmation
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v("Are you sure you want to mark this item as shortage?")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.markBagShortage('Shortage')
      }
    }
  }, [_vm._v("Confirm")]), _vm._v(" "), _c('button', {
    staticClass: "common-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.CloseConfirmation
    }
  }, [_vm._v("Cancel")])])])])], 1) : _vm._e(), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg",
      "title": "Confirmation"
    },
    model: {
      value: (_vm.CargoParentMPSDataModel),
      callback: function($$v) {
        _vm.CargoParentMPSDataModel = $$v
      },
      expression: "CargoParentMPSDataModel"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Parent MPS Details")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeCargoParentMPSDataModel
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table table-bordered mytable12",
    staticStyle: {
      "width": "98%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Shipment Status")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.CargoParentMPSDetails), function(data, index) {
    return (_vm.CargoParentMPSDetails.length > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.shippingid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.status))])]) : _vm._e()
  }), _vm._v(" "), (_vm.CargoParentMPSDetails.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "14"
    }
  }, [_vm._v("No record found")])]) : _vm._e()], 2)])])])])])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "#confirmationmodal",
      "title": "Confirmation",
      "no-close-on-backdrop": true,
      "no-close-on-esc": true
    },
    model: {
      value: (_vm.IsPaperWorkBag),
      callback: function($$v) {
        _vm.IsPaperWorkBag = $$v
      },
      expression: "IsPaperWorkBag"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Paper Work")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closePaperWorkBagCard
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('label', [_vm._v("Hub Name:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('span', [_vm._v(_vm._s(_vm.hubName))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('label', [_vm._v("Paper Bag No:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-shopping-bag'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paperbagno),
      expression: "paperbagno"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Bag No",
      "name": "PaperBagNo",
      "id": "PaperBagNo",
      "autocomplete": "off",
      "disabled": _vm.isExistBag
    },
    domProps: {
      "value": (_vm.paperbagno)
    },
    on: {
      "keyup": _vm.checkPaperBagNo,
      "keypress": function($event) {
        return _vm.checkBarcodeForPaperBagOrParentAWB($event)
      },
      "cut": function($event) {
        $event.preventDefault();
      },
      "paste": [function($event) {
        $event.preventDefault();
      }, function($event) {
        $event.preventDefault();
      }],
      "copy": [function($event) {
        $event.preventDefault();
      }, function($event) {
        $event.preventDefault();
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paperbagno = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.PaperBagNoError))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "color": "blue"
    },
    on: {
      "click": _vm.getPendingPaperBagCount
    }
  }, [_c('b', [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reload PaperBag Count")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('label', [_vm._v("Pending Paper Bag Count: ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.PendingPaperBagsCount))])])])]), _vm._v(" "), (_vm.IsParentAWB == true) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('label', [_vm._v("Parent AWB:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-shopping-bag'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.parentAWB),
      expression: "parentAWB"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Parent AWB",
      "name": "ParentAWB",
      "id": "ParentAWB",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.parentAWB)
    },
    on: {
      "keypress": function($event) {
        return _vm.checkBarcodeForPaperBagOrParentAWB($event)
      },
      "cut": function($event) {
        $event.preventDefault();
      },
      "paste": [function($event) {
        $event.preventDefault();
      }, function($event) {
        $event.preventDefault();
      }],
      "copy": [function($event) {
        $event.preventDefault();
      }, function($event) {
        $event.preventDefault();
      }],
      "keyup": _vm.checkParentAWB,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.parentAWB = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.ParentAWBError))])], 1)]) : _vm._e(), _vm._v(" "), (_vm.missroutemsg) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.missroutemsg))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-5 checkbox"
  }, [_c('b-form-fieldset', [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isexceptional),
      expression: "isexceptional"
    }],
    attrs: {
      "type": "checkbox",
      "id": "IsExceptional",
      "value": "IsExceptional"
    },
    domProps: {
      "checked": Array.isArray(_vm.isexceptional) ? _vm._i(_vm.isexceptional, "IsExceptional") > -1 : (_vm.isexceptional)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isexceptional,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "IsExceptional",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isexceptional = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isexceptional = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isexceptional = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check",
    staticStyle: {
      "cursor": "pointer"
    }
  })])]), _c('label', {
    attrs: {
      "for": "IsExceptional"
    }
  }, [_vm._v("Is Exceptional:")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-shopping-bag'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exceptionreason),
      expression: "exceptionreason"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "name": "Exception",
      "disabled": _vm.isexceptional == false
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.exceptionreason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v("Select")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("SHIPMENT RECEIVED PAPERWORK NOT RECEIVED")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Misroute"
    }
  }, [_vm._v("Misroute")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ForcedMajor"
    }
  }, [_vm._v("Forced Major")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ConnectionChange"
    }
  }, [_vm._v("Connection Change")])])]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.ExceptionError))])], 1)]), _vm._v(" "), (_vm.IsMissingPaperBag) ? _c('legend', [_vm._v("Mark Paper Bag Missing")]) : _vm._e(), _vm._v(" "), (_vm.IsMissingPaperBag) ? _c('b-card', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Paper Bag:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-shopping-bag'></i>"
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.missingpaperbaglist,
      "selected-option": _vm.missingpaperbagitem,
      "name": "PaperBag",
      "placeholder": "Select Paper Bag"
    },
    on: {
      "select": _vm.selectedMissingPaperBag
    },
    model: {
      value: (_vm.missingpaperbag),
      callback: function($$v) {
        _vm.missingpaperbag = $$v
      },
      expression: "missingpaperbag"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.MissingPaperBagError))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Reason:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.missingreason),
      expression: "missingreason"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "name": "Reason"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.missingreason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.checkMissingReason]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v("Select Reason")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Lost"
    }
  }, [_vm._v("Lost")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Missing"
    }
  }, [_vm._v("Missing")])])]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.MissingReasonError))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.markPaperBagMissing
    }
  }, [_vm._v("Mark Paper Bag Missing")]), _vm._v(" \n                  "), _c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetMissingPaperBagField
    }
  }, [_vm._v("Close")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-left": "35%"
    }
  }, [(_vm.IsParentAWB == false) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.scanPaperWorkBag
    }
  }, [_vm._v("Scan In")]) : _vm._e(), _vm._v(" "), (_vm.IsParentAWB == true) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.scanPaperWorkBag(1)
      }
    }
  }, [_vm._v("Scan In")]) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "btn btn-secondary",
    staticStyle: {
      "margin-bottom": "4px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openMissingPaperBagModal
    }
  }, [_vm._v("Paper Bag Missing")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetBag
    }
  }, [_vm._v("Reset")])], 1)]), _vm._v(" "), _c('span', {
    staticStyle: {
      "cursor": "pointer",
      "color": "blue"
    },
    on: {
      "click": _vm.getGeneratedPaperBagNoDetails
    }
  }, [_c('b', [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reload PaperBag Details")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('fieldset', {
    staticStyle: {
      "margin-left": "16px",
      "width": "1032px"
    }
  }, [_c('div', {
    staticClass: "scrollitcls"
  }, [_c('table', {
    staticClass: "table table-bordered mytable12",
    staticStyle: {
      "width": "98%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Parent Bag No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Parent AWB")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Weight")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("MPS Count")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.generatedPaperBagDetails), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.parentbagno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.paperno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.parentmpsstatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.parentawbweight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.mpscount))])])
  }), 0)])])])])])])], 1)])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.showPendingList = false
      }
    },
    model: {
      value: (_vm.showPendingList),
      callback: function($$v) {
        _vm.showPendingList = $$v
      },
      expression: "showPendingList"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Pending List")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closePendingWorkBagList
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('fieldset', {
    staticStyle: {
      "margin": "14px",
      "width": "1032px"
    }
  }, [_c('div', [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Trip Sheet No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Bag No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Parent AWB")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Route")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("OutScan Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Connection")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("NPSCount")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.parentBagDetails), function(data, index) {
    return [_c('tr', {
      class: {
        viewdata: _vm.viewdata.includes(index)
      }
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.thcno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.paperbagno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "color": "#20a8d8",
        "cursor": "pointer",
        "font-weight": "bold"
      },
      on: {
        "click": function($event) {
          return _vm.getPendingMPSList(data, index)
        }
      }
    }, [_vm._v(_vm._s(data.paperno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.routemode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.outscandate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.connectionname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.pendingCount))])]), _vm._v(" "), (_vm.viewdata.includes(index)) ? _c('tr', {
      attrs: {
        "id": 'Parent' + index
      }
    }, [_c('td', {
      attrs: {
        "colspan": 12
      }
    }, [_c('br'), _vm._v(" "), _c('b-card', {
      staticStyle: {
        "margin": "15px",
        "-webkit-box-shadow": "-7px 7px 25px -1px rgba(87,84,82,1)",
        "-moz-box-shadow": "-7px 7px 25px -1px rgba(87,84,82,1)",
        "box-shadow": "-7px 7px 25px -1px rgba(87,84,82,1)"
      }
    }, [_c('legend', {
      staticClass: "header1"
    }, [_vm._v("Paper Work"), _c('i', {
      staticClass: "fa fa-close fa-lg mt-2",
      staticStyle: {
        "float": "right",
        "cursor": "pointer"
      },
      attrs: {
        "title": "Close List"
      },
      on: {
        "click": _vm.closePendingMPSList
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-body",
      staticStyle: {
        "padding": "0.25rem !important"
      }
    }, [_c('table', {
      staticClass: "table-bordered table",
      staticStyle: {
        "position": "relative",
        "overflow": "auto",
        "font-size": "12px",
        "margin-left1": "49px"
      }
    }, [_c('thead', {
      staticClass: "table table-bordered mytable12 poform_tableheader"
    }, [_c('tr', [_c('th', {
      staticStyle: {
        "text-align": "center",
        "padding": "5px",
        "width": "5%"
      }
    }, [_vm._v("Parent AWB")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "text-align": "center",
        "padding": "5px"
      }
    }, [_vm._v(" Bag No/ Shipments")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "text-align": "center",
        "padding": "5px"
      }
    }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "text-align": "center",
        "padding": "5px"
      }
    }, [_vm._v("Weight")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "text-align": "center",
        "padding": "5px"
      }
    }, [_vm._v("Created Date")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "text-align": "center",
        "padding": "5px"
      }
    }, [_vm._v("Action")])])]), _vm._v(" "), _vm._l((_vm.childBagDetails), function(bdata, ind) {
      return (_vm.childBagDetails.length > 0) ? _c('tbody', [_c('tr', [_c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(bdata.parentMPS))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(bdata.shippingid))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(bdata.status))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(bdata.chargeableweight))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(_vm._f("moment")(bdata.createddate)))]), _vm._v(" "), _c('td', {
        staticClass: "text-center",
        staticStyle: {
          "color": "#20a8d8",
          "font-weight": "bold"
        }
      }, [_vm._v("Mark Shortage")])])]) : _vm._e()
    }), _vm._v(" "), (_vm.childBagDetails.length == 0) ? _c('tbody', [_c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "colspan": "12"
      }
    }, [_vm._v("No Bag Details added")])])]) : _vm._e()], 2)])])], 1)]) : _vm._e()]
  }), _vm._v(" "), (_vm.parentBagDetails.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("No Record found")])]) : _vm._e()], 2)])])])])])])])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmitflt('flt')
      }
    }
  }, [_c('fieldset', [_c('legend', [_vm._v("Mark Bag Shortage")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: "fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  }, [_vm._v(" Filter")])]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Connection Type")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-archive'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.connectiontype),
      expression: "connectiontype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('flt.Connection Type')
    },
    attrs: {
      "name": "Connection Type",
      "data-vv-scope": "flt"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.connectiontype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getConnectionName]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v("Select Connection Type")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Linehaul")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Local")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Network")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("BrooksNBonds")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('flt.Connection Type')),
      expression: "errors.has('flt.Connection Type')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('flt.Connection Type')) + " ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Connection Name")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-signs'></i>"
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('flt.Connection Name')
    },
    attrs: {
      "options": _vm.connectionfltlist,
      "selected-option": _vm.connectionfltitem,
      "name": "Connection Name",
      "placeholder": "Select Connection",
      "data-vv-scope": "flt"
    },
    on: {
      "select": _vm.searchConnection
    },
    model: {
      value: (_vm.connectionname),
      callback: function($$v) {
        _vm.connectionname = $$v
      },
      expression: "connectionname"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('flt.Connection Name')),
      expression: "errors.has('flt.Connection Name')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('flt.Connection Name')) + " ")]), _vm._v(" "), (_vm.isConnectionError) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.ConnectionError))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.connectionLoading))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Bag No")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-archive'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bagno),
      expression: "bagno"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Bag No",
      "name": "bagno",
      "id": "bagno"
    },
    domProps: {
      "value": (_vm.bagno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bagno = $event.target.value
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "margin-left": "785px"
    }
  }, [(!_vm.bagno) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.getBagShortageData
    }
  }, [_vm._v("Search")]) : _vm._e(), _vm._v(" "), (_vm.bagno) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.showBagData
    }
  }, [_vm._v("Search")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "background-color": "#3c7ec5",
      "border-color": "#3c7ec5"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetflt
    }
  }, [_vm._v("Reset")])])])])])], 1), _vm._v(" "), (_vm.IsOverageShipmentBagTable) ? _c('div', [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Route Mode")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Connection Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Final Destination")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("No Of Bags")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.BagShortageData), function(data, index) {
    return [_c('tr', {
      class: {
        opened: _vm.opened.includes(index)
      }
    }, [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.routemode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.connectionname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.hubname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "color": "#20a8d8",
        "cursor": "pointer",
        "font-weight": "bold"
      },
      attrs: {
        "title": "View BagDetails"
      },
      on: {
        "click": function($event) {
          return _vm.getBagDetails(data, index)
        }
      }
    }, [_vm._v(_vm._s(data.noofbags))])]), _vm._v(" "), (_vm.opened.includes(index)) ? _c('tr', {
      attrs: {
        "id": 'Route' + index
      }
    }, [_c('td', {
      attrs: {
        "colspan": 12
      }
    }, [_c('br'), _vm._v(" "), _c('b-card', {
      staticStyle: {
        "margin": "15px",
        "-webkit-box-shadow": "-7px 7px 25px -1px rgba(87,84,82,1)",
        "-moz-box-shadow": "-7px 7px 25px -1px rgba(87,84,82,1)",
        "box-shadow": "-7px 7px 25px -1px rgba(87,84,82,1)"
      }
    }, [_c('legend', {
      staticClass: "header1"
    }, [_vm._v("Bag Details "), _c('i', {
      staticClass: "fa fa-close fa-lg mt-2",
      staticStyle: {
        "margin-left": "87%",
        "cursor": "pointer"
      },
      attrs: {
        "title": "Close List"
      },
      on: {
        "click": _vm.closeBagDetailsList
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-body",
      staticStyle: {
        "padding": "0.25rem !important"
      }
    }, [_c('table', {
      staticClass: "table-bordered table",
      staticStyle: {
        "position": "relative",
        "overflow": "auto",
        "font-size": "12px",
        "margin-left1": "49px"
      }
    }, [_c('thead', {
      staticClass: "table table-bordered mytable12 poform_tableheader"
    }, [_c('tr', [_c('th', {
      staticStyle: {
        "text-align": "center",
        "padding": "5px",
        "width": "5%"
      }
    }, [_vm._v("Bag No")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "text-align": "center",
        "padding": "5px"
      }
    }, [_vm._v("Total Shipments")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "text-align": "center",
        "padding": "5px"
      }
    }, [_vm._v("Physical Weight")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "text-align": "center",
        "padding": "5px"
      }
    }, [_vm._v("Volumetric Weight")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "text-align": "center",
        "padding": "5px"
      }
    }, [_vm._v("Action")])])]), _vm._v(" "), _vm._l((_vm.BagDetails), function(bdata, ind) {
      return (_vm.BagDetails.length > 0) ? _c('tbody', [_c('tr', [_c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(bdata.bagnumber))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(bdata.noOfShipments))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(bdata.physicalweight))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(bdata.volumetricweight))]), _vm._v(" "), _c('td', {
        staticClass: "text-center",
        staticStyle: {
          "color": "#20a8d8",
          "cursor": "pointer",
          "font-weight": "bold"
        },
        on: {
          "click": function($event) {
            return _vm.openModal(bdata)
          }
        }
      }, [_vm._v("Mark Shortage")])])]) : _vm._e()
    }), _vm._v(" "), (_vm.BagDetails.length == 0) ? _c('tbody', [_c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "colspan": "12"
      }
    }, [_vm._v("No Bag Details added")])])]) : _vm._e()], 2)])])], 1)]) : _vm._e()]
  }), _vm._v(" "), (_vm.BagShortageData.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("No Record found")])]) : _vm._e()], 2)])]) : _vm._e(), _vm._v(" "), (_vm.IsBagDetailsTable) ? _c('div', {
    staticClass: "card-body",
    staticStyle: {
      "padding": "0.25rem !important"
    }
  }, [_c('table', {
    staticClass: "table-bordered table",
    staticStyle: {
      "position": "relative",
      "overflow": "auto",
      "font-size": "12px",
      "margin-left1": "49px"
    }
  }, [_c('thead', {
    staticClass: "table table-bordered mytable12 poform_tableheader"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "text-align": "center",
      "padding": "5px",
      "width": "5%"
    }
  }, [_vm._v("Bag No")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center",
      "padding": "5px"
    }
  }, [_vm._v("Total Shipments")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center",
      "padding": "5px"
    }
  }, [_vm._v("Physical Weight")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center",
      "padding": "5px"
    }
  }, [_vm._v("Volumetric Weight")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center",
      "padding": "5px"
    }
  }, [_vm._v("Action")])])]), _vm._v(" "), _vm._l((_vm.BagData), function(bdata, ind) {
    return (_vm.BagData.length > 0) ? _c('tbody', [_c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(bdata.bagnumber))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(bdata.noOfShipments))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(bdata.physicalweight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(bdata.volumetricweight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "color": "#20a8d8",
        "cursor": "pointer",
        "font-weight": "bold"
      },
      on: {
        "click": function($event) {
          return _vm.openModal(bdata)
        }
      }
    }, [_vm._v("Mark Shortage")])])]) : _vm._e()
  }), _vm._v(" "), (_vm.BagData.length == 0) ? _c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("No Bag Details added")])])]) : _vm._e()], 2)]) : _vm._e()], 1)], 1)]), _vm._v(" "), (_vm.updatemodal == true) ? _c('b-modal', {
    attrs: {
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.updatemodal = false
      }
    },
    model: {
      value: (_vm.updatemodal),
      callback: function($$v) {
        _vm.updatemodal = $$v
      },
      expression: "updatemodal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Update Vehicle Seal")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeUpdateModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', [_c('b', [_vm._v("Trip Sheet No:")]), _vm._v(" " + _vm._s(_vm.tripsheetno))])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('span', [_c('b', [_vm._v("Invoice No:")]), _vm._v(" " + _vm._s(_vm.invoiceno))])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('span', [_c('b', [_vm._v("Vehicle No:")]), _vm._v(" " + _vm._s(_vm.vehicleno))])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "display": "inline-flex"
    }
  }, [_c('span', [_c('b', [_vm._v("Vehicle Seal No:")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.updatedVehicleSealNo),
      expression: "updatedVehicleSealNo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('checkprefix'),
      expression: "'checkprefix'"
    }],
    staticClass: "effect-1",
    attrs: {
      "type": "text",
      "placeholder": "Enter Vehicle Seal No",
      "name": "VehicleSealNo",
      "id": "VehicleSealNo"
    },
    domProps: {
      "value": (_vm.updatedVehicleSealNo)
    },
    on: {
      "keyup": _vm.clearError,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.updatedVehicleSealNo = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.IsVehicleSealNoError) ? _c('span', {
    staticClass: "text-danger",
    staticStyle: {
      "margin-left": "94px"
    }
  }, [_vm._v(_vm._s(_vm.VehicleSealNoError))]) : _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('VehicleSealNo')),
      expression: "errors.has('VehicleSealNo')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('VehicleSealNo')))])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "float": "right",
      "margin-top": "-30px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.UpdateVehicle
    }
  }, [_vm._v("Update Seal")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": [function($event) {
        _vm.updatemodal = false
      }, _vm.closeUpdateModal]
    }
  }, [_vm._v("Close")])])])])]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.modalShow = false
      }
    },
    model: {
      value: (_vm.modalShow),
      callback: function($$v) {
        _vm.modalShow = $$v
      },
      expression: "modalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-form-fieldset', [_c('span', [_vm._v("Do you want to Mark Bag & Shipments Shortage?")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Shortage Reason")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-road'></i>"
    }
  }, [_c('basic-select', {
    attrs: {
      "options": _vm.reasonlist,
      "selected-option": _vm.reasonitem,
      "name": "reason",
      "placeholder": "Select Reason"
    },
    on: {
      "select": _vm.selectReason
    },
    model: {
      value: (_vm.reason),
      callback: function($$v) {
        _vm.reason = $$v
      },
      expression: "reason"
    }
  })], 1)], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "float": "right",
      "margin-top": "-30px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.markBagShortage
    }
  }, [_vm._v("Mark Shortage")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Cancel")])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.PDDBagModal = false
      }
    },
    model: {
      value: (_vm.PDDBagModal),
      callback: function($$v) {
        _vm.PDDBagModal = $$v
      },
      expression: "PDDBagModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closePDDBagModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v(_vm._s(_vm.ModalStatus))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": [_vm.processPDDBag, function($event) {
        _vm.PDDBagModal = false
      }]
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closePDDBagModal
    }
  }, [_vm._v("No")])])])])]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Prealert")]), _vm._v(" "), (_vm.IsPrealertData) ? _c('b-card', [(_vm.PrealertTripData.length > 0) ? _c('span', {
    staticStyle: {
      "cursor": "pointer",
      "color": "blue"
    },
    on: {
      "click": function($event) {
        return _vm.getPrealertTripData(1)
      }
    }
  }, [_c('b', [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reload Prealert Details")])]) : _vm._e(), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables tablerow",
    staticStyle: {
      "background-color": "white",
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Sch. ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Connection")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Mode")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Outscan Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bags")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Pending Bags")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.PrealertTripData), function(data, index) {
    return [_c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(data.connectionschedulemasterid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.connectionname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.routemode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.outscandate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "color": "#20a8d8",
        "cursor": "pointer",
        "font-weight": "bold"
      },
      attrs: {
        "title": "View BagDetails"
      },
      on: {
        "click": function($event) {
          return _vm.getPrealertBagData(data, index)
        }
      }
    }, [_vm._v(_vm._s(data.noofbags))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.noofpendingbags))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "btn-primary",
      on: {
        "click": function($event) {
          return _vm.getPrealertBagShortageData(data, index)
        }
      }
    }, [_vm._v("Action")])])])]
  }), _vm._v(" "), (_vm.PrealertTripData.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("No Record found")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.Prealertmodal = false
      }
    },
    model: {
      value: (_vm.PrealertPrintmodal),
      callback: function($$v) {
        _vm.PrealertPrintmodal = $$v
      },
      expression: "PrealertPrintmodal"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Bag Details Sheet")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closePrealertPrintmodal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "form-group row",
    attrs: {
      "id": "printData"
    }
  }, [_c('table', [_c('tr', [_c('td', [_c('strong', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("Xpressbess Linehaul Connection Bag Details Sheet")])])])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered datatables tablerow",
    staticStyle: {
      "background-color": "white",
      "width": "100%",
      "margin-bottom": "20px"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Connection Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Route Mode")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Vehicle Number")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Departure Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Departure Time")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("No of Bags")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.prealertConnection))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.PrintData.routemode))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.prealertVehicle))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm._f("momentPrealert")(_vm.prealertInvoiceDate)))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.prealertInvoiceTime))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.PrintData.noofbags))])])])]), _vm._v(" "), [_c('table', {
    staticClass: "table-bordered datatables tablerow",
    staticStyle: {
      "background-color": "white",
      "width": "100%",
      "margin-bottom": "20px"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Sr.No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Bag No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Bag Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Destination")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("No of Shipments")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Phy.wt")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Vot.wt")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Remarks")])]), _vm._v(" "), _vm._l((_vm.PrealertBagData), function(bdata, ind) {
    return (_vm.PrealertBagData.length > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(ind + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(bdata.parentbagno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(bdata.bagstatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(bdata.bagdestinationhub))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(bdata.bagshipmentscnt))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(bdata.physicalweight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(bdata.volumetricweight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    })]) : _vm._e()
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "1"
    }
  }, [_c('strong', [_vm._v("Total:")])]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "1"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "1"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "1"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "1"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.totalshipment))])]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "1"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.totalphysicalwt))])]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "1"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.totalvolumetricwt))])]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "1"
    }
  })])], 2)]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered tbl datatables tablerow",
    staticStyle: {
      "background-color": "white",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Driver's Sign : ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Receiver's Sign :")])])])])])]], 2), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "margin-left": "38%"
    },
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.download
    }
  }, [_vm._v("Download Prealert")])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.Prealertmodal = false
      }
    },
    model: {
      value: (_vm.Prealertmodal),
      callback: function($$v) {
        _vm.Prealertmodal = $$v
      },
      expression: "Prealertmodal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Bag Shortage List")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closePrealertmodal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables tablerow",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag No")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.PrealertBagShortageList), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedRow),
        expression: "selectedRow"
      }],
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": data,
        "checked": _vm._q(_vm.selectedRow, data)
      },
      on: {
        "change": [function($event) {
          _vm.selectedRow = data
        }, _vm.selectBag]
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagno))])])
  }), _vm._v(" "), (_vm.PrealertBagShortageList.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("No bag found")])]) : _vm._e()], 2)]), _vm._v(" "), (_vm.selectedRowError != '') ? _c('tr', [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.selectedRowError))])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Shortage Reason")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-road'></i>"
    }
  }, [_c('basic-select', {
    attrs: {
      "options": _vm.reasonlist,
      "selected-option": _vm.reasonitem,
      "name": "reason",
      "placeholder": "Select Reason"
    },
    on: {
      "select": _vm.selectReason
    },
    model: {
      value: (_vm.reason),
      callback: function($$v) {
        _vm.reason = $$v
      },
      expression: "reason"
    }
  })], 1), _vm._v(" "), (_vm.Isreasonerror) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.reasonError))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "margin-top": "35px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.markBagShortage
    }
  }, [_vm._v("Confirm")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.resetModalField
    }
  }, [_vm._v("Clear")])])])])])])])], 1) : _vm._e()], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.UnloadingSheetModel),
      callback: function($$v) {
        _vm.UnloadingSheetModel = $$v
      },
      expression: "UnloadingSheetModel"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Unloading Sheet Print")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeUnloadingSheetModel
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('b-card', [_c('fieldset', [_c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.IsUnloadingSheet),
      expression: "IsUnloadingSheet"
    }],
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Trip Sheet No")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.unloadingtripsheetno),
      expression: "unloadingtripsheetno"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Trip Sheet No",
      "name": "TripSheetNo",
      "id": "TripSheetNo"
    },
    domProps: {
      "value": (_vm.unloadingtripsheetno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.unloadingtripsheetno = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.TripSheetNoError) ? _c('span', [_vm._v(_vm._s(_vm.TripSheetNoError))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "margin-top": "29px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.getUnloadingTripSheetDetails
    }
  }, [_vm._v("Get Trip Details")]), _vm._v(" \n                          "), _c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelUnloadingSheetField
    }
  }, [_vm._v("Cancel")])])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingSheetModal
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingSheetModal = $event
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.IsSheet == true) ? _c('div', [_c('div', {
    attrs: {
      "id": "tripsheetContent"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-left",
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Print By :")]), _vm._v(" " + _vm._s(_vm.printBy))]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Print Date :")]), _vm._v(" " + _vm._s(_vm.printDate))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("Xpressbees Trip Unloading Sheet")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left",
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Receiving Hub : ")]), _vm._v(" " + _vm._s(_vm.hubName) + " ")]), _vm._v(" "), _c('td', {
    staticClass: "text-left",
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Date: ")]), _vm._v(" " + _vm._s(_vm._f("moment")(_vm.UnloadingTripData[0].date)) + " ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left",
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v("Route :")]), _vm._v(" " + _vm._s(_vm.UnloadingTripData[0].route) + " ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left",
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v("THC No : ")]), _vm._v(" " + _vm._s(_vm.UnloadingTripData[0].thcno))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left",
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v("Vehicle No : ")]), _vm._v(" " + _vm._s(_vm.UnloadingTripData[0].vehicleno))])])])]), _vm._v(" "), _c('br'), _vm._v(" "), [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('strong', [_vm._v("Sr No.")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('strong', [_vm._v("Check")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('strong', [_vm._v("PLS Bag No")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('strong', [_vm._v("Origin Hub")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('strong', [_vm._v("AWB No")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('strong', [_vm._v("MPS Count")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('strong', [_vm._v("Weight")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('strong', [_vm._v("AWB Destination")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('strong', [_vm._v("Remarks")])])]), _vm._v(" "), _vm._l((_vm.UnloadingBagData), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedbags),
        expression: "selectedbags"
      }],
      staticStyle: {
        "font-size": "0.8em"
      },
      attrs: {
        "type": "checkbox",
        "name": 'selectedbags' + index
      },
      domProps: {
        "value": data,
        "checked": Array.isArray(_vm.selectedbags) ? _vm._i(_vm.selectedbags, data) > -1 : (_vm.selectedbags)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selectedbags,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedbags = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedbags = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedbags = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.getBag(data.parentbagno)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.currenthubname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.awbno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.mpscount))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.parentawbweight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.stoppointhubname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    })])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Total")])]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("toFixedNum")(_vm.gettotalMPSCount(_vm.UnloadingBagData))))])]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("toFixedNum")(_vm.gettotalWeight(_vm.UnloadingBagData))))])]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "bottom",
      "colspan": "4",
      "height": "100"
    }
  }, [_vm._v("Vehicle Loaded By")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "bottom",
      "colspan": "5",
      "height": "100"
    }
  }, [_vm._v("Sign")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "bottom",
      "colspan": "4",
      "height": "100"
    }
  }, [_vm._v("Fleet Supervisor/Exec.Signature")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "bottom",
      "colspan": "5",
      "height": "100"
    }
  }, [_vm._v("Driver's Sign")])])], 2)])]], 2), _vm._v(" "), _c('div', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.printSheet
    }
  }, [_vm._v("Print")])])]) : _vm._e()], 1)]), _vm._v(" "), _c('br')])], 1)])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": "Confirmation"
    },
    model: {
      value: (_vm.closeVehicleModal),
      callback: function($$v) {
        _vm.closeVehicleModal = $$v
      },
      expression: "closeVehicleModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hideCloseVehicleModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b', {
    staticStyle: {
      "color": "red",
      "margin-left": "-4%"
    }
  }, [_vm._v(_vm._s(_vm.CloseVehicleMsg))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeVehicle('Yes')
      }
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.hideCloseVehicleModal
    }
  }, [_vm._v("No")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  })])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": "Confirmation"
    },
    model: {
      value: (_vm.invalidTokenModal),
      callback: function($$v) {
        _vm.invalidTokenModal = $$v
      },
      expression: "invalidTokenModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeinvalidTokenModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v(_vm._s(_vm.invalidtokenmsg))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Logout")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeinvalidTokenModal
    }
  }, [_vm._v("Cancel")])])])])])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07433763","hasScoped":true}!./src/views/components/CenterScanInTrip_v1/CenterScanInTrip_v1.html
// module id = 1729
// module chunks = 2